import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Container, Col } from "react-bootstrap";
import "../CodeOverview/CodeOverview.scss";
import ReactMarkdown from "react-markdown";
import Scrollbars from "react-custom-scrollbars-2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboard, faDownload, faCheck, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import CustomButton from "../../common-components/button/Button.jsx";

import { setShowValidator } from "../../state/reducers/securityValidator";

function Validator() {
  const { config_file, fs_file } = useSelector((state) => state.securityValidator);
  const [copied, setCopied] = useState(false);
  const dispatch = useDispatch()

  const copyToClipboard = () => {
    const textToCopy = `${config_file}\n\n${fs_file}`;
    navigator.clipboard.writeText(textToCopy).then(() => {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    }, (err) => {
      console.error("Could not copy text: ", err);
    });
  };

  const downloadResult = () => {
    const textToDownload = `${config_file}\n\n${fs_file}`;
    const element = document.createElement("a");
    const file = new Blob([textToDownload], {type: "text/plain"});
    element.href = URL.createObjectURL(file);
    element.download = "securityValidatorData.txt";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return (
    <div className="page-wrapper code-overview-page px-3">
      <Container>
        <Row>
          <Col>
            <h2 className="page-title">Security Validator</h2>
            <div className="code-overview-wrapper">
              <Row>
                <Col>
                  <div className="overview-text-wrapper position-relative">
                    <button className="copy-btn" onClick={copyToClipboard}>
                      <FontAwesomeIcon icon={copied ? faCheck : faClipboard} className="copy-icon"/> <span>Copy</span>
                    </button>
                    <Scrollbars>
                      <div className="spec-content">
                        <ReactMarkdown className="overview-text spec-text mb-4">
                          {config_file}
                        </ReactMarkdown>
                        <ReactMarkdown className="overview-text spec-text mb-4">
                          {fs_file}
                        </ReactMarkdown>
                      </div>
                    </Scrollbars>
                  </div>
                  <div className="text-end">
                    <CustomButton label={<><FontAwesomeIcon icon={faAngleLeft} className="dld-icon" /> <span>Back</span></>} onClick={() => dispatch(setShowValidator(false))} className="back-btn" />
                    <button className="download-btn" onClick={downloadResult}>
                      <FontAwesomeIcon icon={faDownload} className="dld-icon" /> <span>Download Security Validator</span>
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Validator;